import styled from 'styled-components';
import { IC_RADIO, IC_RADIO_CHECKED, IC_GREEN_RADIO_CHECKED, IC_RADIO_HC_CHECKED } from '../../../Assets/images';

export const RadioButtonStyled = styled.div`
  .form-check {
    margin: 0;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: flex-start;

    label {
      max-width: calc(100% - 30px);
      font-size: 17px;
      line-height: 19px;
      cursor: pointer;
    }
    &.lineHeight24 {
      label {
        line-height: 24px;
      }
    }
    &.font-14-bold {
      label {
        font-size: 14px;
        font-weight: 700;
      }
    }
    &.font-14-med {
      label {
        font-size: 14px;
        font-weight: 600;
      }
    }
    &.font-15-med {
      label {
        font-size: 15px;
        font-weight: 600;
        color: ${(props) => props.theme.text.dark};
      }
    }

    .form-check-input[type='radio'] {
      width: 24px;
      height: 24px;
      background: url(${IC_RADIO.src}) no-repeat 50% 50%;
      border: 0;
      margin: 0 7px 0 0;
      cursor: pointer;

      &:focus {
        box-shadow: 0 0 0;
      }

      &:checked {
        background: url(${IC_RADIO_CHECKED.src}) no-repeat 50% 50%;
      }
    }
    .is-invalid {
      border-color: ${(props) => props.theme.verification.red.main};
    }
  }
  &.epharmacy {
    .form-check {
      .form-check-input[type='radio'] {
        &:checked {
          background: url(${IC_GREEN_RADIO_CHECKED.src}) no-repeat 50% 50%;
        }
      }
    }
  }
  &.homecare{
    .form-check {
      .form-check-input[type='radio'] {
        &:checked {
          background: url(${IC_RADIO_HC_CHECKED.src}) no-repeat 50% 50%;
        }
      }
    }
  }
`;
